import React from "react";
import { capitalize } from "../../utils/textFunctions";

const Ethnicity = ({ data }) => {
  return (
    <div>
      <h4>Ethnicity</h4>
      {data.length
        ? data.map((ethnicity, index) => (
            <div key={index}>
              {ethnicity.extension[0].valueCoding.display
                ? capitalize(ethnicity.extension[0].valueCoding.display)
                : ethnicity.extension[0].valueCoding.code}
            </div>
          ))
        : "NA"}
    </div>
  );
};

export default Ethnicity;
